import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Skeleton, styled } from '@mui/material';
import DateInput from 'components/DateInput';

type HypothesisDateProps = {
    applicationDate: string | undefined;
    onDateChange: (newDate: string) => void;
    isLoading: boolean;
    disabled?: boolean;
};

const StyDateField = styled(DateInput)(() => ({
    '.MuiInputBase-root': {
        backgroundColor: 'white',
    },
    '.MuiInputBase-input': {
        fontSize: '12px',
        padding: '12px 14px',
    },
    '.Mui-disabled': {
        color: 'black', // text color
        backgroundColor: 'transparent',
        fontSize: '12px',
    },
    width: '100%',
}));

const HypothesisDate = ({
    applicationDate,
    onDateChange,
    isLoading,
    disabled = false,
}: HypothesisDateProps) => {
    const { t } = useTranslation();

    return (
        <>
            <Typography variant="body1" sx={{ fontSize: '10px' }}>
                {t('humanResources.simulation.applicationDate')}
            </Typography>
            {isLoading ? (
                <Skeleton />
            ) : (
                <StyDateField
                    value={applicationDate}
                    onChange={onDateChange}
                    disabled={disabled}
                />
            )}
        </>
    );
};

export default memo(HypothesisDate);
